import { cn } from '@/lib/utils';
import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';

const InputGroupVarient = cva('flex ', {
  variants: {
    direction: {
      horizontal: 'flex-row flex-nowrap',
      vertical: 'flex-col',
    },
    columns: {
      '1': '[&>*]:basis-full',
      '2': '[&>*]:basis-1/2',
      '3': '[&>*]:basis-1/3',
      '4': '[&>*]:basis-1/4',
      '5': '[&>*]:basis-1/5',
      '6': '[&>*]:basis-1/6',
    },
    gap: {
      sm: 'gap-2 ',
      md: 'gap-4.5',
      lg: 'gap-6',
    },
  },
  compoundVariants: [
    { direction: 'vertical', columns: '1', className: '' },
    { direction: 'vertical', columns: '2', className: '' },
    { direction: 'vertical', columns: '3', className: '' },
    { direction: 'vertical', columns: '4', className: '' },
    { direction: 'vertical', columns: '5', className: '' },
    { direction: 'vertical', columns: '6', className: '' },
  ],
  defaultVariants: {
    direction: 'horizontal',
    columns: '1',
    gap: 'md',
  },
});

type InputGroupLayoutProps = React.HTMLAttributes<HTMLDivElement> & VariantProps<typeof InputGroupVarient>;

const InputGroupLayout: React.FC<InputGroupLayoutProps> = ({ className, direction, columns, gap, ...props }) => {
  return <div className={cn(InputGroupVarient({ direction, columns, gap }), className)} {...props} />;
};

export { InputGroupLayout };
